/* LITMUS cart behaviour.

   One job: intercept the subscribe-in-cart link so switching a line to a
   subscription updates the cart in place instead of navigating. The link's own
   href performs the same change and redirects to the cart, so with scripting
   off the control still works — it just costs a page load.

   It has to be a link: both cart surfaces already sit inside a form, and a
   nested form is dropped by the HTML parser.

   Section rendering follows Dawn's own contract: ask /cart/change.js for the
   sections the current surface owns, then swap their inner HTML. */
(function () {
  'use strict';

  // The drawer is included on the cart page, which also includes this asset.
  if (window.litmusCartSubscribeBound) return;
  window.litmusCartSubscribeBound = true;

  var DRAWER = [
    { id: 'cart-drawer', selector: '#CartDrawer' },
    { id: 'cart-icon-bubble', selector: '.shopify-section' }
  ];
  var PAGE = [
    { id: 'main-cart-items', selector: '.js-contents' },
    { id: 'main-cart-footer', selector: '.js-contents' },
    { id: 'cart-icon-bubble', selector: '.shopify-section' },
    { id: 'cart-live-region-text', selector: '.shopify-section' }
  ];

  function sectionsFor(form) {
    if (form.closest('#CartDrawer')) return DRAWER;
    return PAGE;
  }

  /* main-cart-items / main-cart-footer are addressed by their live section id,
     which Dawn stores on the wrapper as data-id. */
  function sectionId(entry) {
    if (entry.id === 'main-cart-items' || entry.id === 'main-cart-footer') {
      var host = document.getElementById(entry.id);
      return host && host.dataset.id ? host.dataset.id : entry.id;
    }
    return entry.id;
  }

  function patchSection(html, entry) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    if (entry.id === 'cart-drawer') {
      // Keep #CartDrawer and its overlay: Dawn binds the overlay click once.
      ['cart-drawer-items', '.drawer__footer'].forEach(function (selector) {
        var current = document.querySelector('#CartDrawer ' + selector);
        var next = doc.querySelector('#CartDrawer ' + selector);
        if (current && next) current.replaceWith(next);
      });
      return;
    }
    var root = document.getElementById(entry.id);
    var current = root && (root.querySelector(entry.selector) || root);
    var next = doc.querySelector(entry.selector);
    if (current && next) current.innerHTML = next.innerHTML;
  }

  function announce(message, inDrawer) {
    var live = document.getElementById(inDrawer ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text');
    if (live) live.textContent = message;
  }

  function submit(control) {
    var sections = sectionsFor(control);
    var inDrawer = !!control.closest('#CartDrawer');
    var itemId = control.closest('.cart-item') && control.closest('.cart-item').id;
    control.setAttribute('aria-busy', 'true');

    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: control.dataset.line,
        quantity: Number(control.dataset.quantity),
        selling_plan: Number(control.dataset.plan),
        sections: sections.map(sectionId).join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (!state || state.errors || !state.sections) throw new Error('Plan update failed');
        sections.forEach(function (entry) {
          var html = state.sections[sectionId(entry)];
          if (html) patchSection(html, entry);
        });
        announce('Delivery plan updated.', inDrawer);
        if (window.publish && window.PUB_SUB_EVENTS) {
          // Sections were already patched; avoid Dawn fetching and replacing them again.
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: state });
        }
        var item = itemId && document.getElementById(itemId);
        var focus = item && item.querySelector('.cart-item__name');
        // Shopify can merge two lines on a plan change, removing the old row ID.
        if (!focus) focus = document.querySelector(inDrawer ? '#CartDrawer .cart-item__name' : '#main-cart-items .cart-item__name');
        if (!focus && inDrawer) focus = document.querySelector('#CartDrawer .drawer__header .drawer__close');
        if (focus) focus.focus();
      })
      .catch(function () {
        control.removeAttribute('aria-busy');
        announce('Could not update the delivery plan. Try again.', inDrawer);
      });
  }

  document.addEventListener('click', function (event) {
    var control = event.target.closest('[data-litmus-subscribe]');
    if (!control) return;
    /* Leave modified clicks alone: a new tab should still get the real URL. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (control.hasAttribute('aria-busy')) return;
    submit(control);
  });
})();
